import { Description } from "./Description";
import { Item } from "./Item";
import { Label } from "./Label";
import { Mark } from "./Mark";
import { Root } from "./Root";

export const RadioGroup = {
  Root,
  Item,
  Label,
  Description,
  Mark,
};

export type { RadioGroupDescriptionProps } from "./Description";
export type { RadioGroupItemProps } from "./Item";
export type { RadioGroupLabelProps } from "./Label";
export type { RadioGroupMarkProps } from "./Mark";
export type { RadioGroupRootProps } from "./Root";
